import { connectionReducer } from "./connectionReducer";
import { interviewReducer } from "./interview/interviewReducer";
import { applicationReducer } from "./applicationReducer";
import { StoreState } from "../../models/states/StoreState";
import { errorsReducer } from "./errorsReducer";
import { recallReducer } from "./recallReducer";
import { lookupTableReducer } from "./lookupTableReducer";
import { recallModeReducer } from "./recallModeReducer";
import { mobilePreviewReducer } from "./mobilePreviewReducer";
import { filesReducer } from "./filesReducer";
import { ActionTypes } from "../actions/types";
import { SET_IS_INPUT_FOCUSED, SET_PAGE_MESSAGES_ENABLED } from "../actions";
import { RecallMode } from "../../models/enums/RecallMode";

const INITIAL_STATE: StoreState = {
    application: undefined,
    connection: undefined,
    errors: undefined,
    interview: undefined,
    lookupTable: undefined,
    recall: undefined,
    recallMode: RecallMode.Enabled,
    isPageMessagesEnabled: true,
    isFormInputFocused: false,
    mobilePreview: false,
    files: undefined,
};

const isPageMessagesEnabledReducer = (state: boolean, action: ActionTypes) => {
    if (action.type === SET_PAGE_MESSAGES_ENABLED) {
        return action.isPageMessageEnabled;
    }
    return state;
};

const isFormInputFocusedReducer = (state: boolean, action: ActionTypes) => {
    if (action.type === SET_IS_INPUT_FOCUSED) {
        return action.isInputFocused;
    }
    return state;
};

export const rootReducer = (state = INITIAL_STATE, action: ActionTypes): StoreState => {
    const previousPage =
        state.interview !== undefined ? state.interview.navigation.currentPage : undefined;
    const interview = interviewReducer(state.interview, action);
    return {
        interview,
        connection: connectionReducer(state.connection, action),
        application: applicationReducer(state.application, action),
        mobilePreview: mobilePreviewReducer(state.mobilePreview, action),
        recallMode: recallModeReducer(state.recallMode, action),
        isPageMessagesEnabled: isPageMessagesEnabledReducer(state.isPageMessagesEnabled, action),
        errors: errorsReducer(state.errors, action),
        lookupTable: lookupTableReducer(state.lookupTable, action),
        recall: recallReducer(state.recall, action, interview, previousPage),
        files: filesReducer(state.files, action),
        isFormInputFocused: isFormInputFocusedReducer(state.isFormInputFocused, action),
    };
};
